@import '~style-sheet-helpers/core.less';

.note-body-textarea {
  margin-bottom: 10px;
  margin-top: 10px;
  display: block;
  resize: none;
  height: 200px;
  width: 100%;
}

.note-type-message {
  font-size: 12px;
}
